import { render } from "./TopicCommentDetail.vue?vue&type=template&id=02aef418&scoped=true"
import script from "./TopicCommentDetail.vue?vue&type=script&lang=ts"
export * from "./TopicCommentDetail.vue?vue&type=script&lang=ts"

import "./TopicCommentDetail.vue?vue&type=style&index=0&id=02aef418&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02aef418"

export default script